import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import EducationStepLabel from '#client/components/CheckDeposit/components/EducationStepLabel';
import { EducationSteps } from '#client/components/CheckDeposit/components/EducationSteps';

import ScanQRCodeBanner from './ScanQRCodeBanner';

import { ImageWrapperStyled, TextWrapStyled } from './styles';

const stepsToRender = [
  { step: EducationSteps.prepTheCheck },
  { step: EducationSteps.positionInsideTheLines },
  { step: EducationSteps.followTheGuidelines },
  { step: EducationSteps.WhenToAccessFunds }
];

const OtherReasons = ({ isShowBanner = false }) => (
  <Stack
    aria-label="Other reasons"
    pb="64px"
  >
    <TextWrapStyled>
      <Text
        color="tertiary"
        size="md"
      >
        Please review these steps and try again.
      </Text>
    </TextWrapStyled>
    {isShowBanner && (
      <Box mb="40px">
        <ScanQRCodeBanner />
      </Box>
    )}
    {stepsToRender.map(({ step }, i) => (
      <Stack
        aria-label="education step"
        key={`${step?.title}_${i + 1}`}
        pb="40px"
        spacing="16px"
      >
        <EducationStepLabel
          number={i + 1}
          step={step}
          total={stepsToRender.length}
        />
        {step?.content && (
          <Stack
            pl="40px"
            spacing="16px"
          >
            {step.content()}
          </Stack>
        )}
        {step?.image && <ImageWrapperStyled>{step.image}</ImageWrapperStyled>}
      </Stack>
    ))}
  </Stack>
);

OtherReasons.propTypes = {
  isShowBanner: PropTypes.bool
};

export default OtherReasons;
